import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';


const commonRoutes = {
    getUser: (page: number, size: number, identifier: string) => `v1/users?page=${page}&size=${size}&identifier=${identifier}`,
    getNotificationConfigList: () => `v1/user-notification-config`,
    updateNotificationConfigList: () => `v1/user-notification-config`,
    getBusinessEntityListing: () => `v1/business-entities`,
    getBusinessEntityGroupList: () => `v1/business-entity-group`,
    getUserByUserID: (userId: any) => `v1/users/${userId}`,
    getRoles: () => `v1/roles`,
    updateUserStatus: () => `v1/users/active-status`,
    createNewBusinessEntityGroup: () => `v1/business-entity-group`,
    createDomainGroup: () => `v1/domain-group`,
    updateUser: () => `v1/users`,
    createUser: () => `v1/users`,
    getBusinessGroupByGroupId: (businessEntityGroupId: any) => `v1/business-entity-group?${businessEntityGroupId}`,
    updateUserPassword: () => `v1/users/update-password`,
    updateBusinessEntityGroup: () => `v1/business-entity-group`,
    updateDomainGroup: () => `v1/domain-group`,
    getDomainVOList: () => `v1/domain-vos`,
    getDomainGroupList: () => `v1/domain-group`,
};

const rolesRoute = {
    getAllFpModule: () => `v1/fp-module`,
    getPagedRoles: (page: number, size: number) => `v1/role-vos?page=${page}&size=${size}`,
    getRoleByRoleId: (roleId: any) => `v1/role-vos/${roleId}`,
    updateRole: () => `v1/role-vos`,
    createRole: () => `v1/role-vos`
};


@Injectable({
    providedIn: 'root'
})
export class AdminControlService {

    constructor(private http: HttpClient) {
    }

    getBusinessGroupByGroupId(businessEntityGroupId: any) {
        const $entityGroup: Observable<any> = this.http
            .get(commonRoutes.getBusinessGroupByGroupId(businessEntityGroupId))
            .pipe(
                map((res) => {
                    return res as any;
                })
            );
        return $entityGroup;
    }

    getNotificationConfigList() {
        const $configList: Observable<any> = this.http
            .get(commonRoutes.getNotificationConfigList())
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $configList;
    }

    updateUserStatus(userStatusBody: any) {
        const $userStatus: Observable<any> = this.http
            // @ts-ignore
            .put(commonRoutes.updateUserStatus(), userStatusBody)
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $userStatus;
    }

    getUser(page: number, size: number, identifier: string) {
        const $user: Observable<any> = this.http
            .get(commonRoutes.getUser(page, size, identifier))
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $user;
    }

    getPagedRoles(page: number, size: number) {
        const $roles: Observable<any> = this.http
            .get(rolesRoute.getPagedRoles(page, size))
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $roles;
    }

    getAllFpModule() {
        const $fpRoles: Observable<any> = this.http
            .get(rolesRoute.getAllFpModule())
            .pipe(
                map((res) => {
                    return res as any;
                })
            );
        return $fpRoles;
    }

    getRoleByRoleId(roleId: string) {
        const $role: Observable<any> = this.http
            .get(rolesRoute.getRoleByRoleId(roleId))
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $role;
    }


    getRoles() {
        const $roles: Observable<any> = this.http
            .get(commonRoutes.getRoles())
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $roles;
    }

    getUserByUserID(userId: any) {
        const $user: Observable<any> = this.http
            .get(commonRoutes.getUserByUserID(userId))
            .pipe(
                map((res) => {
                    return res as any;
                })
            );
        return $user;
    }

    getBusinessEntityGroupList() {
        const $companyGroupList: Observable<any> = this.http
            .get(commonRoutes.getBusinessEntityGroupList())
            .pipe(
                map((res) => {
                    return res as any;
                })
            );
        return $companyGroupList;
    }

    getBusinessEntityListing() {
        const $companyListing: Observable<any> = this.http
            .get(commonRoutes.getBusinessEntityListing())
            .pipe(
                map((res) => {
                    return res as any;
                })
            );
        return $companyListing;
    }

    getDomainGroupList() {
        const $domainGroup: Observable<any> = this.http
            .get(commonRoutes.getDomainGroupList())
            .pipe(
                map((res) => {
                    return res as any;
                })
            );
        return $domainGroup;
    }


    createNewBusinessEntityGroup(businessEntityBody: any) {
        const $businessEntity: Observable<any> = this.http
            .post(commonRoutes.createNewBusinessEntityGroup(), businessEntityBody)
            .pipe(
                map((res: any) => {
                    return res as any;
                })
            );
        return $businessEntity;
    }

    createDomainGroup(domainGroupBody: any) {
        const $domainGroup: Observable<any> = this.http
            .post(commonRoutes.createDomainGroup(), domainGroupBody)
            .pipe(
                map((res: any) => {
                    return res as any;
                })
            );
        return $domainGroup;
    }

    getDomainVOList() {
        const $domains: Observable<any> = this.http
            .get(commonRoutes.getDomainVOList())
            .pipe(
                map((res) => {
                    return res as any;
                })
            );
        return $domains;
    }

    updateBusinessEntityGroup(businessEntityBody: any) {
        const $businessEntity: Observable<any> = this.http
            .put(commonRoutes.updateBusinessEntityGroup(), businessEntityBody)
            .pipe(
                map((res: any) => {
                    return res as any;
                })
            );
        return $businessEntity;
    }

    updateDomainGroup(domainGroupBody: any) {
        const $domainGroup: Observable<any> = this.http
            .put(commonRoutes.updateDomainGroup(), domainGroupBody)
            .pipe(
                map((res: any) => {
                    return res as any;
                })
            );
        return $domainGroup;
    }

    createRole(roleVO: any) {
        const $role: Observable<any> = this.http
            .post(rolesRoute.createRole(), roleVO)
            .pipe(
                map((res: any) => {
                    return res as any;
                })
            );
        return $role;
    }

    updateRole(roleVO: any) {
        const $role: Observable<any> = this.http
            .put(rolesRoute.updateRole(), roleVO)
            .pipe(
                map((res: any) => {
                    return res as any;
                })
            );
        return $role;
    }

    updateUser(userRequestBody: any) {
        const $user: Observable<any> = this.http
            .put(commonRoutes.updateUser(), userRequestBody)
            .pipe(
                map((res) => {
                    return res as any;
                })
            );
        return $user;
    }

    updateUserPassword(userRequestBody: any) {
        const $user: Observable<any> = this.http
            .put(commonRoutes.updateUserPassword(), userRequestBody)
            .pipe(
                map((res) => {
                    return res as any;
                })
            );
        return $user;
    }

    createUser(userRequestBody: any) {
        const $user: Observable<any> = this.http
            .post(commonRoutes.createUser(), userRequestBody)
            .pipe(
                map((res) => {
                    return res as any;
                })
            );
        return $user;
    }

    updateNotificationConfigList(notificationRequestBody: any) {
        const $configList: Observable<any> = this.http
            .put(commonRoutes.updateNotificationConfigList(), notificationRequestBody)
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $configList;
    }
}
